var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMileage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C7.942 8 1.332 14.61 1.332 22.666H3.4c0-6.92 5.68-12.6 12.6-12.6s12.6 5.68 12.6 12.6h2.066C30.77 14.61 24.16 8 16 8z",
    fill: "#0E0E0E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.238 21.736l2.892-6.403-6.403 2.892c-.826.413-1.343 1.343-1.343 2.272a2.557 2.557 0 002.582 2.582c1.033 0 1.86-.516 2.272-1.343z",
    fill: "#0E0E0E"
  })));
}
export default SvgMileage;